module.exports = __webpack_public_path__ + "img/153-cuba.5d0e09a0.svg";